module.exports = __webpack_public_path__ + "img/twint.634a669b.svg";